// Public status page — skips the code gate and auth guard. M014
// refactor: body extracted into StatusCards so the in-project Status
// tab can render the same surface. The standalone page keeps the
// auto-reload-on-frontend-SHA behaviour so operators watching
// /status see the site reload itself on deploy.

import { ChromeCorners } from "../layout/ChromeCorners";
import { StatusCards } from "./StatusCards";

export function StatusPage() {
  return (
    <div className="flex min-h-screen items-center justify-center p-8 text-primary transition-colors">
      <ChromeCorners />
      <main className="w-full max-w-4xl">
        <StatusCards reloadOnFrontendSha />
      </main>
    </div>
  );
}
